import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { NgChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule, GoogleChartsSettings } from 'ng2-google-charts';
import { HttpClientModule } from '@angular/common/http';




@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    Ng2GoogleChartsModule,
    NgChartsModule,
    HttpClientModule
  ]
})
export class DashboardModule { }
